// Results reach the client from two engine generations: the live edge function
// (deployed from main, possibly older than this build) and rows saved before the
// fund-schedule fields existed. Both may lack hpeMoic / hpeFundLabel. Fill them
// from what the result already carries so no card dereferences undefined.
import type { TaxResults } from './types';

export const LEGACY_FUND_LABEL = 'Saved schedule (re-save to refresh)';

export function normalizeAltFundFields<T extends TaxResults | null | undefined>(results: T): T {
  if (!results) return results;
  const r = results as TaxResults;
  if (typeof r.hpeMoic === 'number' && typeof r.hpeFundLabel === 'string' && Array.isArray(r.hpeCashFlows)) {
    return results;
  }
  const flows = Array.isArray(r.hpeCashFlows) ? r.hpeCashFlows : [];
  const invested = -(flows[0] ?? 0);
  const cashBack = r.hpeNetCashReturned ?? 0;
  return {
    ...r,
    hpeCashFlows: flows,
    hpeMoic: typeof r.hpeMoic === 'number' ? r.hpeMoic : invested > 0 ? cashBack / invested : 0,
    hpeFundVintageId: r.hpeFundVintageId ?? '',
    hpeFundLabel: r.hpeFundLabel ?? LEGACY_FUND_LABEL,
  } as T;
}
